// src/admin/pages/FinancialReports.jsx
import React from 'react';
import DocumentsPage from './DocumentsPage';

export default function FinancialReports() {
    return (
        <DocumentsPage
            category="financial_report"
            title="Financial Reports"
            description="Upload annual, quarterly, or other financial reports for internal reference."
        />
    );
}
